module.exports = __webpack_public_path__ + "img/27.485addb0.jpg";